import { BASE_URL, FREE_BASE_URL } from "../BaseUrl.js";
import axios from "axios";

axios.interceptors.request.use(function (config) {
  const token = localStorage.getItem("cc_pssm_api");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  } else {
    config.headers.Authorization = null;
  }

  return config;
}, function (error) {
  console.log('AN ERROR REQUEST', error)
});

const currentAnnee = localStorage.getItem("currentAnnee")
  ? JSON.parse(localStorage.getItem("currentAnnee"))
  : null;

export const listeDesRolePaginee = async (page = 1, size = 10, param = "") => {  
  return await axios.get(
    BASE_URL(`profil/query?page=${page}&size=${size}&param=${param}`),
    {}
  );
};

export const listeCompleteDesRole = async () => {
  return await axios.get(
    FREE_BASE_URL(`profil`),
    {}
  );
};


export const recupereRoleParSonId = async (niveauId) => {
  return await axios.get(
    BASE_URL(`profil/${niveauId}`),
    {}
  );
};

export const ajouterUneRole = async (values) => {
  return await axios.post(
    BASE_URL(`profil`),
    values
  );
};

export const ajouterPermissionParMenuAuRole = async (values) => {
  return await axios.post(
    BASE_URL(`profil/update-permissions`),
    values
  );
};

export const retirerMenuAssocieAuRole = async (profil, menu) => {
  return await axios.post(
    BASE_URL(`profil/${profil}/remove-menu/${menu}`),
    {}
  );
};

export const modifierUneRole = async (values, niveauId) => {
  return await axios.put(
    BASE_URL(`profil/${niveauId}`),
    values
  );
};

export const supprimerUneRole = async (niveauId) => {
  return await axios.delete(
    BASE_URL(`profil/${niveauId}`),
    {}
  );
};
